import { logger } from "./logger";
import { install as installProductFilterTracking } from "./product-filtering";
import { install as installProductViewedTracking } from "./product-viewed";
import { domReadyLegacy } from "./../utils/ready";

type Variables = {
  timeout?: number;
};

export function install(
  _variables: Variables,
  _context?: FeatureContext
): void {
  domReadyLegacy(async () => {
    const errors: Error[] = [];

    try {
      installProductFilterTracking();
    } catch (e) {
      errors.push(e);
      logger.error(e);
    }

    try {
      installProductViewedTracking();
    } catch (e) {
      errors.push(e);
      logger.error(e);
    }

    for (const err of errors) {
      throw err;
    }
  });
}
